
// export const baseurl = "https://api.springwayhub.com/mlm/";
// export const imgBaseurl = "https://api.springwayhub.com";

import { APP_BASE_URL_FROM_CONFIG, IMG_BASE_URL_FROM_CONFIG } from "../config";

export const baseurl = APP_BASE_URL_FROM_CONFIG
export const imgBaseurl = IMG_BASE_URL_FROM_CONFIG
